import { getEnv } from "@/util/env.ts";

const svgList = import.meta.glob("@/assets/category/*.svg", {
  as: "url",
  eager: true,
});

const resolveAlias = (path: string) => {
  return path.replace("@", "src");
};

export const getMenuIconUrl = (code: string) => {
  return svgList[resolveAlias(`@/assets/category/${code}.svg`.replace("@", "/src"))];
};

export const getIconUrl = (path: string | null) => {
  if (!path?.length) return path;
  const { PUBLIC_B2C_ASSETS_HOST } = getEnv();
  return PUBLIC_B2C_ASSETS_HOST + "/" + path;
};